import React, { ReactElement } from 'react';

function BubbleIcon({ className }: { className: string }): ReactElement {
    return (
        <svg
            className={className}
            height="12"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
        >
            <path d="m10.94,2.64c-.55-.75-1.29-1.34-2.13-1.73-.92-.43-1.93-.65-2.94-.64-1.02-.01-2.03.21-2.95.64-.84.39-1.57.98-2.13,1.73C.28,3.33,0,4.17,0,5.03c0,1.09.44,2.12,1.21,2.89-.16.43-.38.83-.66,1.19-.12.18-.26.35-.4.51-.07.08-.12.17-.14.27-.02.1,0,.21.04.31.04.09.11.18.2.24s.2.09.3.09c1.15-.01,2.26-.38,3.19-1.05.69.21,1.4.32,2.13.32.33,0,.66-.02.99-.06,0-.11-.02-.23-.02-.34,0-.14.01-.28.03-.42-.33.07-.66.09-1,.09-.65,0-1.29-.1-1.9-.3l-.35-.12-.3.23c-.69.5-1.5.81-2.35.89.39-.47.71-1,.93-1.58l.16-.43-.32-.35c-.63-.63-.99-1.48-1-2.38,0-.73.24-1.44.68-2.02.49-.65,1.13-1.15,1.87-1.47.81-.36,1.69-.55,2.58-.54.88,0,1.76.17,2.57.54.74.32,1.38.82,1.87,1.46.44.58.69,1.3.69,2.03,0,.59-.16,1.17-.46,1.68.23.07.45.18.65.31.35-.6.54-1.29.54-1.99,0-.86-.28-1.7-.79-2.39Z" />
            <path
                fill="#f8aa4c"
                d="m12,9.4c0,1.29-1.04,2.33-2.33,2.33-1.21,0-2.19-.91-2.32-2.08-.01-.08-.01-.17-.01-.25,0-.18.02-.35.06-.52.23-1.04,1.16-1.81,2.27-1.81.2,0,.39.02.57.07.24.06.47.16.68.3.65.4,1.08,1.13,1.08,1.96Z"
            />
        </svg>
    );
}

export default BubbleIcon;
